import './CompteClient.scss';

import { useState } from 'react';
import { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import {useLocation, useNavigate } from 'react-router-dom';
import { useParams } from 'react-router-dom';

import useAxiosPrivate from '../../../hooks/useAxiosPrivate';
import useWindowSize from '../../../hooks/useWindowSize';
import {SideBarNavigationFicheExpert } from '../../../Styles/componentStyles';
import DonnesFacturationParent from './DonnesFacturationParent';
import SideBar from './SideBarGestionClient';

function CompteClientDonneeFacturationById() {
    const {pathname} = useLocation();
    const currentPath = pathname.split('/').pop();
    const axiosPrivate = useAxiosPrivate();
    const navigate = useNavigate();
    let param = useParams();
    const [nomEntreprise,setNomEntreprise]=useState('');
    const { i18n } = useTranslation();

    const {device}=useWindowSize();

    useEffect(() => {
        getClientbyId();
    }, []);

    const getClientbyId = async () => {
        let endpoint = pathname.includes('gestionEsn') ? '/users/getEsnById/':'/users/getClientById/';
        try {
            const response = await axiosPrivate.get(endpoint+(param.ClientId ?? param.EsnId));
            setNomEntreprise(response?.data?.profileEntreprise?.nom);
            console.log('dataClient',response?.data?.profileEntreprise?.nom);
        } catch (error) {
            console.log(error);
        }
    };

    return (
        <>
            <div style={{display:'flex',flexDirection:'column',alignItems: 'flex-start',alignSelf:'stretch',gap:'24px'}}>
                <div className='frame5Profile'>{location?.pathname?.includes('gestionEsn')  ? i18n.t('Gestion des Esn'):i18n.t('Gestion des Clients')} &gt; <span style={{color:'rgba(39, 45, 60, 1)'}}>{nomEntreprise} </span> </div>
                <div style={{display:'flex',flexDirection:device=='desktop'?'row':'column',alignSelf:'stretch',gap:'24px'}}>
                    <SideBar/>
                    <div style={{display:'flex',flexDirection:'column',justifyContent:'space-between',width:device=='desktop'?'85%':'100%',minWidth:device=='desktop'?'500px':'200px',alignItems: 'center',gap:'24px'}}>
                        <div
                            className='frame6CompteExpert'
                            style={{flexDirection:'row',width:'100%',flexWrap:'wrap'}}
                        >
                            <div
                                className='frame4CompteClient'
                                style={
                                    currentPath == 'CompteClient' ? SideBarNavigationFicheExpert.selectedTitle : SideBarNavigationFicheExpert.notSelectedTitle
                                }
                            >
                                <p

                                    style={
                                        currentPath == 'CompteClient' ? SideBarNavigationFicheExpert.selectedTitleP : SideBarNavigationFicheExpert.notSelectedTitleP
                                    }
                                    onClick={()=>{

                                        navigate('/'+((pathname.split('/')).slice(1,-1)).join('/')+'/CompteClient', { replace: true });
                                    }}

                                >{i18n.t('Données Générales')}</p>
                            </div>

                            <div
                                className='frame5CompteClient'
                                style={
                                    currentPath == 'DonneeFacturation' ? SideBarNavigationFicheExpert.selectedTitle : SideBarNavigationFicheExpert.notSelectedTitle
                                }
                            >
                                <p
                                    style={
                                        currentPath == 'DonneeFacturation' ? SideBarNavigationFicheExpert.selectedTitleP : SideBarNavigationFicheExpert.notSelectedTitleP
                                    }
                                    onClick={()=>{
                                        if(currentPath == 'DonneeFacturation')
                                            navigate('.');
                                        else
                                            navigate('/'+((pathname.split('/')).slice(1,-1)).join('/')+'/DonneeFacturation', { replace: true });

                                    }}
                                >{i18n.t('Données Facturation')}</p>
                            </div>
                            <div
                                className='frame5CompteClient'
                                style={
                                    currentPath == 'PrestationComplementaire' ? SideBarNavigationFicheExpert.selectedTitle : SideBarNavigationFicheExpert.notSelectedTitle
                                }
                            >
                                <p
                                    style={
                                        currentPath == 'PrestationComplementaire' ?
                                            SideBarNavigationFicheExpert.selectedTitleP : SideBarNavigationFicheExpert.notSelectedTitleP
                                    }
                                    onClick={()=>{
                                        navigate('/'+((pathname.split('/')).slice(1,-1)).join('/')+'/PrestationComplementaire', { replace: true });

                                    }}

                                >{i18n.t('Prestation Complémentaire')}</p>
                            </div>
                        </div>
                        <DonnesFacturationParent />
                    </div>
                </div>
            </div>
        </>
    );
}
export default CompteClientDonneeFacturationById;